export const DisableTips = {
  // 商品已下架
  PRODUCT_OFF_SALE: "商品已下架",
  // 商品已售罄
  PRODUCT_SOLD_OUT: "商品已售罄",
  // 商品超出配送区域
  PRODUCT_OUT_OF_AREA: "商品区域无货",
};
